// @flow
import Draw from './Draw';
import Modify from './Modify';
import Select from './Select';
import Translate from './Translate';

export default {
    Draw,
    Modify,
    Select,
    Translate
}